import { defineBlock } from "eddev/blocks"
import { Container, Grid, Col } from "@components/layout/Grid"
import { useEffect, useState } from "react"
import { TimedCards } from "@components/molecules/Cards"
import { Swiper, SwiperSlide } from "@components/atoms/Swiper"

export const meta: BlockMeta = {
  title: "Timed cards",
  category: "common",
  icon: "images-alt",
  keywords: ["cards"],
  tags: ["root"],
  editMode: "preview",
  lazyLoad: false,
  conditions: {
    postTypes: ["page", "post"],
  },
}

const slideTime = 5000

export default defineBlock("general/timed-cards", (props) => {
  const [swiperEl, setSwiperEl] = useState<any>()
  const [timerKey, setTimerKey] = useState(0)

  function handleSwiperInit(swiper: any) {
    setSwiperEl(swiper)
  }

  function handleSlideChange() {
    setTimerKey((prevKey) => prevKey + 1)
  }

  useEffect(() => {
    if (swiperEl) {
      swiperEl.on("slideChange", handleSlideChange)
    }
    return () => {
      if (swiperEl) {
        swiperEl.off("slideChange", handleSlideChange)
      }
    }
  }, [swiperEl])

  return (
    <Container className="my-5">
      <Grid>
        <Col initial={12}>
          {props.cards && (
            <>
              <style>{`
                .timed-cards-swiper {
                  overflow: visible !important;
                }
              `}</style>
              <Swiper
                className="timed-cards-swiper"
                onSwiper={handleSwiperInit}
                slidesPerView={1}
                autoplay={{
                  delay: slideTime,
                }}
                loop
                effect="fade"
                fadeEffect={{
                  crossFade: true,
                }}
                children={props.cards?.map((card, i) => {
                if (card?.__typename !== "Page") return <></>
                return (
                  <SwiperSlide key={i}>
                    <TimedCards
                      title={card.title! ?? undefined}
                      heading={card.nextHeading ?? undefined}
                      content={card.nextContent ?? undefined}
                      imageLink={card.nextHeroimage ?? undefined}
                      primaryLink={{
                        href: card?.uri ?? undefined,
                        icon: "ARROW_RIGHT",
                        iconStyle: "right",
                        color: "yellow",
                        size: "tiny",
                        children: `Learn more about ${card.title}`,
                      }}
                      chips={props.cards?.map((chip, k) => ({
                        color: k === i ? "black" : "grey",
                        children:
                          k === i ? (
                            <div className="flex items-center">
                              <Timer key={timerKey} /> {chip?.title}
                            </div>
                          ) : (
                            <div className="flex items-center">{chip?.title}</div>
                          ),
                        onClick: () => swiperEl.slideTo(k),
                      }))}
                    />
                  </SwiperSlide>
                )
              })}
              />
            </>
          )}
        </Col>
      </Grid>
    </Container>
  )
})

const Timer = () => (
  <div
    className={
      "relative w-[12px] h-[12px] border border-white shadow-[inset_0_0_1px_white] rounded-full bg-transparent " +
      "[background-image:linear-gradient(90deg,#222222_50%,#ffffff_50%)] overflow-hidden mr-2 " +
      "after:absolute after:left-1/2 after:w-1/2 after:h-full after:content-[''] after:bg-black after:origin-[0_50%] " +
      "after:animate-[pie-timer_5500ms_linear_infinite]"
    }
  />
)
